module.exports = __webpack_public_path__ + "static/media/request-accepted-banner.fdb8f18b.png";